const initShopTheLookDots = () => {
  const dots = document.querySelectorAll('[data-stld-dot]');
  const closeButtons = document.querySelectorAll('[data-stld-close]');

  const openOverlay = (sectionId, blockId, productId) => {
    const overlay = document.getElementById(`stld-overlay-${sectionId}-${blockId}-${productId}`);
    if (!overlay) return;
    overlay.removeAttribute('hidden');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    const firstFocusable = overlay.querySelector('a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) {
      setTimeout(() => firstFocusable.focus(), 100);
    }
  };

  const closeOverlay = (overlay) => {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const sectionId = dot.dataset.sectionId;
      const blockId = dot.dataset.blockId;
      const productId = dot.dataset.productId;
      if (sectionId && blockId && productId) {
        openOverlay(sectionId, blockId, productId);
      }
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const overlay = btn.closest('[data-stld-overlay]');
      closeOverlay(overlay);
    });
  });

  document.querySelectorAll('[data-stld-overlay]').forEach((overlay) => {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeOverlay(overlay);
    });

    overlay.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeOverlay(overlay);
    });
  });
};

document.addEventListener('DOMContentLoaded', initShopTheLookDots);

if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.stld')) initShopTheLookDots();
  });
}
